import { useEffect, useState } from 'react';
import Table, { useTable } from 'common/components/table';
import { Row, Col } from 'reactstrap';

import { useActions } from 'utils/hooks';
import Form from './form';
import useDrawer from 'common/components/drawer/useDrawer';
import company from 'assets/svg/actions/company.svg';
import CheckedButton from 'common/components/buttons/CheckedButton';
import TableActions from 'components/layouts/table';
import TopFilters from './components/TopFilters';
import CorePageUrl from './components/CorePageUrl';

import * as listActions from 'store/lists/actions';

const Reports = () => {
  const [active, setActive] = useState(null);

  const [fetchListOptions] = useActions([listActions.fetchListOptions]);

  const drawer = useDrawer(false);

  const table = useTable({
    label: 'report_types',
    columns: [
      {
        header: 'Type',
        key: 'category',
        type: 'string',
        sort: true,
        width: 2
      },
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        sort: true,
        width: 4
      },
      {
        header: 'Companies',
        key: 'companies',
        sort: true,
        width: 1
      },
      {
        header: 'Core url',
        key: 'core_url',
        sort: false,
        width: 3
      },
      {
        header: 'Show onboard',
        key: 'show_onboard',
        type: 'collection',
        className: 'text-center',
        canFilter: false,
        width: 1
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions',
        className: 'text-center'
      }
    ],
    top: {
      filters: [
        {
          name: 'can_see',
          operation: 'oneOf',
          value: null
        },
        {
          name: 'category',
          operation: '=',
          value: null
        }
      ]
    }
  });

  const { topFilters, setTopFilters } = table;

  useEffect(() => {
    fetchListOptions('beacon-pages-suggestions');
  }, [fetchListOptions]);

  return (
    <>
      <Row>
        <Col xs={12} className="mb-5">
          <TableActions title="Reports" actions={[{ type: 'search' }]} />
        </Col>
        <Col xs={12}>
          <Table
            loader
            hideTableFilters={true}
            topFiltersComponent={
              <TopFilters topFilters={topFilters} setTopFilters={setTopFilters} />
            }
            drawer={<Form drawer={drawer} active={active} refetchData={table.refetchData} />}
            rows={{
              category: data => <div className="text-capitalize">{data.category}</div>,
              companies: data => data.companies_count || 0,
              show_onboard: data => (
                <CheckedButton
                  showShadow={false}
                  hideUncheckedIcon={true}
                  uncheckedIconColor="violet"
                  isChecked={data.is_for_vessel}
                  style={{ height: 17, width: 17 }}
                />
              ),
              actions: {
                options: [
                  {
                    label: 'Edit Visibility',
                    icon: company,
                    onClick: (_, row) => {
                      setActive(row);
                      drawer.open();
                    }
                  }
                ]
              },
              core_url: data => <CorePageUrl label={data.label} prefix="/reports" />
            }}
            {...table}
          />
        </Col>
      </Row>
    </>
  );
};

export default Reports;
